import '@/App.css';
import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { ProtectedRoute } from './components/ProtectedRoute';
import { Toaster } from './components/ui/sonner';
import WhatsAppBadge from "./components/WhatsAppBadge";

import Homepage from './pages/Homepage';
import Products from './pages/Products';
import About from './pages/About';
import Contact from './pages/Contact';
import PaymentInfo from './pages/PaymentInfo';
import Franchise from './pages/Franchise';
import Login from './pages/Login';

import Dashboard from './pages/admin/Dashboard';
import ProductsAdmin from './pages/admin/ProductsAdmin';
import CustomersAdmin from './pages/admin/CustomersAdmin';
import SalesAdmin from './pages/admin/SalesAdmin';
import ExpensesAdmin from './pages/admin/ExpensesAdmin';
import InventoryAdmin from './pages/admin/InventoryAdmin';
import FranchisesAdmin from './pages/admin/FranchisesAdmin';
import UsersAdmin from './pages/admin/UsersAdmin';

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <div className="App">
          <Routes>
            <Route path="/" element={<Homepage />} />
            <Route path="/products" element={<Products />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/payment-info" element={<PaymentInfo />} />
            <Route path="/franchise" element={<Franchise />} />
            <Route path="/login" element={<Login />} />

            <Route path="/admin/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
            <Route path="/admin/products" element={<ProtectedRoute><ProductsAdmin /></ProtectedRoute>} />
            <Route path="/admin/customers" element={<ProtectedRoute><CustomersAdmin /></ProtectedRoute>} />
            <Route path="/admin/sales" element={<ProtectedRoute><SalesAdmin /></ProtectedRoute>} />
            <Route path="/admin/expenses" element={<ProtectedRoute><ExpensesAdmin /></ProtectedRoute>} />
            <Route path="/admin/inventory" element={<ProtectedRoute><InventoryAdmin /></ProtectedRoute>} />
            <Route path="/admin/franchises" element={<ProtectedRoute allowedRoles={['super_admin']}><FranchisesAdmin /></ProtectedRoute>} />
            <Route path="/admin/users" element={<ProtectedRoute allowedRoles={['super_admin', 'franchise_admin']}><UsersAdmin /></ProtectedRoute>} />
          </Routes>
          <WhatsAppBadge />
          <Toaster position="top-left" />
        </div>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
